// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Wrl2","flexColumn":"styles_flexColumn__24DyT","fix":"styles_fix__3FnYR","form":"styles_form__1sVg5","flexibleLimit":"styles_flexibleLimit__2DQNP"};